import { formatDate } from '@angular/common';
import * as moment from 'moment';

import { e2eMode } from '../../../../environments/e2e/e2eMode';
import { formatNumber } from '../../services/utils/data-helpers';

export const colors = {
  completed: '#005EB8',
  ticketed: '#9BCAEB',
  unticketed: '#31a24e'
};

export function getChartOptions(symbolType: string, tile = false) {
  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    scales: {
      yAxes: [
        {
          ticks: {
            fontFamily: "'Source Sans Pro', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            callback(label: number) {
              if (label % 1 !== 0) {
                return '';
              }
              return formatNumber(label, '');
            },
            padding: 10
          },
          stacked: true,
          gridLines: {
            drawBorder: false
          }
        }
      ],
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
            fontFamily: "'Source Sans Pro', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            callback: (value: string) =>
              moment(value)
                .format('MMM')
                .toUpperCase(),
            fontColor: '#666'
          },
          stacked: true,
          gridLines: {
            display: false
          }
        }
      ]
    },
    tooltips: {
      mode: 'index',
      position: 'average',
      cornerRadius: 2,
      multiKeyBackground: 'transparent',
      caretSize: 0,
      backgroundColor: '#e8e8e8',
      titleFontColor: '#3a3a3a',
      bodyFontColor: '#3a3a3a',
      bodyFontSize: 15,
      callbacks: {
        title(tooltipItem: any, data: any) {
          const index = tooltipItem[0].index;
          const date = data.labels[index];

          return moment(date)
            .format('MMMM Y')
            .toUpperCase();
        },
        label(tooltipItem: any) {
          if (!!tooltipItem.yLabel) {
            return ` ${formatNumber(tooltipItem.yLabel, '')} ${symbolType}`;
          }
        }
      }
    }
  };
  if (tile) {
    options.scales.xAxes[0].gridLines.drawBorder = false;
    options.scales.xAxes[0].ticks.lineHeight = 1;
  } else {
    options.layout = {
      padding: {
        left: 0,
        right: 0,
        top: 30,
        bottom: 25
      }
    };
    options.scales.xAxes[0].gridLines.tickMarkLength = 35;
  }
  const tickFontSize = getDocumentFontSize();
  options.onResize = onResize;
  options.scales.xAxes[0].ticks.fontSize = tickFontSize;
  options.scales.yAxes[0].ticks.fontSize = tickFontSize;

  if (e2eMode.e2e) {
    options.animation = false;
  }

  return options;
}

function onResize(chart: any, newSize: { width: number; height: number }) {
  if (0 === newSize.width) {
    // chart being created dynamically (pdf generation)
    return;
  }
  const targetHeight = Math.ceil(newSize.width / 2);
  if (Math.abs(targetHeight - newSize.height) > 10) {
    chart.canvas.parentNode.style.height = targetHeight + 'px';
  }
  const fontSize = getDocumentFontSize();
  chart.options.scales.xAxes[0].ticks.minor.fontSize = fontSize;
  chart.options.scales.yAxes[0].ticks.minor.fontSize = fontSize;
}

function getDocumentFontSize() {
  return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('font-size'), 10);
}

function normalizeDate(date) {
  return date.match(/^\d\d\d\d-\d\d$/) ? date + '-01' : date;
}
